import React from 'react'
import Box, { BoxProps } from '@mui/material/Box'

export const FullHeightBox = ({ children, sx }: Pick<BoxProps, 'children' | 'sx'>) => {
    return (
        <Box
            sx={{
                display: 'flex',
                height: '100%',
                alignItems: 'center',
                ...sx,
            }}
        >
            {children}
        </Box>
    )
}
